import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import errorHandler from "../utils/errorHandler";

type ApiMethod = "POST" | "GET" | "PUT" | "DELETE";

interface ApiCallOptions<D = Record<string, unknown>> {
  instance: AxiosInstance;
  url: string;
  method?: ApiMethod;
  data?: D;
  config?: AxiosRequestConfig;
}

type ApiResponse<R> = R | { items: R };

export const apiCall = async <D = Record<string, unknown>, R = unknown>({
  instance,
  url,
  method = "POST",
  data,
  config = {},
}: ApiCallOptions<D>): Promise<R> => {
  try {
    const response: AxiosResponse<ApiResponse<R>> = await instance({
      url,
      method,
      data,
      headers: {
        "Content-Type": "application/json",
        ...config.headers,
      },
      ...config,
    });
    
 
    if (response.data && typeof response.data === 'object' && 'items' in response.data) {
      return response.data.items;
    }
    
    return response.data as R;
  } catch (err: unknown) {
    if (axios.isAxiosError(err) && err.response?.data) {
      return err.response.data;
    }
    
    errorHandler(err);
    throw err;
  }
};

